import decodeJwt from 'jwt-decode';
import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/authentication`;

export const login = async (username, password) => {
  const headers = getHeaders();
  
  // Check for stored device info
  const deviceId = localStorage.getItem('deviceId');
  const deviceToken = localStorage.getItem('deviceToken');
  
  const requestOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify({ 
      username, 
      password,
      deviceId: deviceId || null,
      deviceToken: deviceToken || null
    }),
  };
  const response = await fetch(`${baseRoute}/login`, requestOptions);

  // Handle MFA required (202 Accepted)
  if (response.status === 202) {
    const data = await response.json();
    return {
      requiresMfa: data.requiresMfa,
      tempToken: data.tempToken,
      message: data.message,
      firstTime: data.firstTime || false,
    };
  }

  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }

  const { token } = await response.json();
  const decodedToken = decodeJwt(token);
  let roles = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  localStorage.setItem('token', token);
  localStorage.setItem('roles', roles);
  return roles;
};

export const selfInspectLogin = async loginDetails => {
  const headers = getHeaders();
  const requestOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify(loginDetails),
  };

  const response = await fetch(`${baseRoute}/selfInspectLogin`, requestOptions);

  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }

  const json = await response.json();
  const { token } = json;

  const decodedToken = decodeJwt(token);
  let roles = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

  localStorage.setItem('token', token);
  localStorage.setItem('roles', roles);

  return json;
};

export const logout = async () => {
  localStorage.removeItem('token');
  localStorage.removeItem('roles');

  return Promise.resolve();
};

export const verifyToken = async jwt => {
  const url = `${baseRoute}/verifytoken`;
  const headers = getHeaders();

  const response = await fetch(url, {
    method: 'POST',
    headers,
  });

  if (response.ok) {
    const json = await response.json();
    const { token, name } = json;
    const decodedToken = decodeJwt(token);
    let roles = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    localStorage.setItem('token', token);
    localStorage.setItem('roles', roles);
    return json;
  }

  throw new Error('Token Unverified');
};
